import React from "react";

import RewardPointsAndBonus from './../../presentation/rewardPointsAndBonus/RewardPointsAndBonus.jsx'

const RewardPointsAndBonusContainer = (props) => {
  return <RewardPointsAndBonus {...props} />
};

export default RewardPointsAndBonusContainer;
